import { Flex, Image, Text } from 'theme-ui'

const styles: StyleObject = {
  container: {
    background: '#FFFFFF',
  },
  content: {
    width: '100%',
    height: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    pl: '50px',
    color: '#000000',

    '& h1': {
      fontFamily: 'bold',
      fontSize: '42px',
      textTransform: 'uppercase',
    },

    '& h2': {
      fontFamily: 'regular',
      fontSize: '18px',
      textTransform: 'uppercase',
    },

    '& button': {
      mt: '24px',
      color: '#3A3A3A',
      border: '1px solid',
      borderColor: '#3A3A3A',
      fontFamily: 'bold',
      fontSize: '20px',
      textTransform: 'uppercase',
      fontStyle: 'normal',
      borderRadius: '40px',
      background: 'transparent',
      padding: '8px 16px',
      transition: 'all 150ms ease-in-out',

      '&:hover': {
        background: '#3A3A3A',
        color: '#FFFFFF',
        cursor: 'pointer',
      },
    },
  },
  image: {
    width: '100%',
    height: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      height: '800px',
      width: 'auto',
      objectFit: 'contain',
    },
  },
}

const NotFound = () => {
  return (
    <Flex sx={styles.container}>
      <Flex sx={styles.content}>
        <Text as="h1">Closed</Text>
        <Text as="h2">This campaign is not available.</Text>
      </Flex>
      <Flex sx={styles.image}>
        <Image src="/static/images/closed-error.jpg" />
      </Flex>
    </Flex>
  )
}

export default NotFound
